export default __webpack_public_path__ + "0767bf9700d30183c53d943442fc05b1.png";